import { Tooltip } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import { MasterDetailsAsideItem } from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { ApplicationSettingItem } from 'src/stores/SettingsStores/SettingsPageStore/SettingsPageStore';

type SettingsListItemProps = { item: ApplicationSettingItem };

export const SettingsListItem = observer(({ item }: SettingsListItemProps) => {
    const name = t(`Page.Setting.List.Item.${item.name}`);

    return (
        <MasterDetailsAsideItem
            small
            to={EntityLinks.settings.itemDetails(item.settingItemId)}
        >
            <Tooltip title={name}>
                <EllipsisContainer>{name}</EllipsisContainer>
            </Tooltip>
        </MasterDetailsAsideItem>
    );
});
